module.exports = "<ul class=\"pagination\" ng-if=\"$ctrl.pages.length > 1\">\n  <li ng-repeat=\"page in $ctrl.pages\" ng-class=\"{'is-active': page.number === $ctrl.currentPage, 'disabled': page.action === undefined}\">\n    <a ng-click=\"page.action(page.number)\">{{page.label}}</a>\n  </li>\n</ul>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/components/pagination/pagination.html
 ** module id = 342
 ** module chunks = 0
 **/